import Affaire from "./Affaire";
import Collection from "./Collection";

export default class CollectionParAffaire {
    public affaire: Affaire;
    public collections: Collection[];

    public constructor() {
        this.affaire = new Affaire();
        this.collections = [];
    }
}